/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type FccStartHandlingVehicleMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type FccStartHandlingVehicleMutation = {
  __typename?: 'Mutation'
  fccStartHandlingVehicle: any | null
}

export const FccStartHandlingVehicleDocument = gql`
    mutation fccStartHandlingVehicle($vehicleId: ID!) {
  fccStartHandlingVehicle(vehicleId: $vehicleId)
}
    `
export type FccStartHandlingVehicleMutationFn = Apollo.MutationFunction<
  FccStartHandlingVehicleMutation,
  FccStartHandlingVehicleMutationVariables
>

/**
 * __useFccStartHandlingVehicleMutation__
 *
 * To run a mutation, you first call `useFccStartHandlingVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccStartHandlingVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccStartHandlingVehicleMutation, { data, loading, error }] = useFccStartHandlingVehicleMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccStartHandlingVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccStartHandlingVehicleMutation,
    FccStartHandlingVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccStartHandlingVehicleMutation,
    FccStartHandlingVehicleMutationVariables
  >(FccStartHandlingVehicleDocument, options)
}
export type FccStartHandlingVehicleMutationHookResult = ReturnType<
  typeof useFccStartHandlingVehicleMutation
>
export type FccStartHandlingVehicleMutationResult =
  Apollo.MutationResult<FccStartHandlingVehicleMutation>
export type FccStartHandlingVehicleMutationOptions = Apollo.BaseMutationOptions<
  FccStartHandlingVehicleMutation,
  FccStartHandlingVehicleMutationVariables
>
